export enum AnnouncementTypeEnum {
  CAMPAIGN = 1,
  ASSIGNMENT = 2,
  SALES_OPPORTUNITY = 3,
  CLIENT = 4,
  CAMPAIGN_SALES_OPPORTUNITY = 5
}